import React from 'react';
import { TextField, useFieldHelper, FieldProps } from 'framework/ui/field';

const SignBox = ({ children }: { children: React.ReactNode }) => (
  <span style={{ display: 'inline-block', width: '1em', textAlign: 'center' }}>{children}</span>
);

const AdditionalHoursField = (props: FieldProps) => {
  const { getValue } = useFieldHelper<string | number>(props);
  const value = getValue();

  const formatHours = () => {
    if (!value && value !== 0) return '—';
    const num = Number(value);
    return (
      <>
        <SignBox>{num < 0 ? '-' : '+'}</SignBox>
        {Math.abs(num)} h
      </>
    );
  };

  return <TextField {...props} value={formatHours()} />;
};

export default AdditionalHoursField;
